import { Container } from 'react-bootstrap';
import PopoverWithAlerts from './PopoverAlerts';

const alertsData = [
  {
    alertDescription:
      'Dental - Basic Plan is not longer available - Select New Plan',
  },
  {
    alertDescription: 'Vision',
  },
];

const PopoverWithAlertsDemo = () => {
  return (
    <Container>
      <PopoverWithAlerts alertsData={alertsData} />
    </Container>
  );
};

export default PopoverWithAlertsDemo;
